import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "isOpen", "className", "duration", "onEntered", "onExited", "lazyMount"];

/* eslint no-param-reassign: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Transition from 'react-transition-group/Transition';

var Collapse = function Collapse(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      className = _ref.className,
      duration = _ref.duration,
      onEntered = _ref.onEntered,
      onExited = _ref.onExited,
      lazyMount = _ref.lazyMount,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleEnter = function handleEnter(node, isAppearing) {
    if (isAppearing) {
      node.style.height = 'auto';
    } else {
      node.style.height = 0;
    }
  };

  var handleEntering = function handleEntering(node) {
    var height = node.scrollHeight;
    node.style.transitionDuration = "".concat(duration, "ms");
    node.style.height = "".concat(height, "px");
  };

  var handleEntered = function handleEntered(node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  };

  var handleExit = function handleExit(node) {
    var height = node.scrollHeight;
    node.style.height = "".concat(height, "px");
  };

  var handleExiting = function handleExiting(node) {
    setTimeout(function () {
      node.style.transitionDuration = "".concat(duration, "ms");
      node.style.height = 0;
    }, 0);
  };

  return /*#__PURE__*/React.createElement(Transition, _extends({
    "in": isOpen,
    appear: true,
    timeout: duration,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onExit: handleExit,
    onExiting: handleExiting,
    onEntered: handleEntered,
    onExited: onExited,
    mountOnEnter: lazyMount,
    unmountOnExit: lazyMount
  }, props, {
    "data-qa": "collapse"
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('w-fill', 'height-0', 'overflow-hidden', className)
  }, children));
};

Collapse.defaultProps = {
  duration: 350,
  lazyMount: false,
  className: ''
};
Collapse.propTypes = {
  /** Indicator whether or not collapse should be open */
  isOpen: PropTypes.bool.isRequired,

  /** Children to render when collapse is open */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,

  /** Duration of the animation */
  duration: PropTypes.number,

  /** Function to be executed when the collapse is opened
   * (node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /** Function to be executed when the collapse is closed
   * (node: HtmlElement, isAppearing: bool) -> void
   */
  onExited: PropTypes.func,

  /** Mount the child component in a lazy fashion.
   * Meaning, mounted when expended and unmounted when collapsed */
  lazyMount: PropTypes.bool,
  className: PropTypes.string
};
export default Collapse;